import DOMPurify from 'isomorphic-dompurify';
import parse from 'html-react-parser';
import MDAvatar from "dashboard/components/MDAvatar";
import loader from "assets/images/shapes/loader.svg";

const EMIJI_REGEX = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g;
const SRC = `${process.env.REACT_APP_PUBLIC_URL}/img/64/`;
const EMOJI_STYLE = "height:32px; width:32px; margin: 0 2px; vertical-align: bottom;";
const loaderAnimation = <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
  src={loader} alt="Avatar" variant="square" size="md" />

const useEmoji = () => {

    function emojiUnicode (emoji) {
        let comp;
        if (emoji.length === 1) {
            comp = emoji.charCodeAt(0);
        }
        comp = (
            (emoji.charCodeAt(0) - 0xD800) * 0x400
            + (emoji.charCodeAt(1) - 0xDC00) + 0x10000
        );
        if (comp < 0) {
            comp = emoji.charCodeAt(0);
        }
        return comp.toString("16") ;
    };

    function replaceAllTextEmojis(text) { 
        let allEmojis = text.match(EMIJI_REGEX); // TODO: get all emoji style 
        let emojiSrc;
        if (allEmojis) {
            allEmojis.push('☺️');
            allEmojis = [...new Set(allEmojis)]; // remove duplicates
            allEmojis.forEach(emoji => {
            if(emoji === "☺️") emojiSrc = `${SRC}1f642.png`;
            else emojiSrc = `${SRC + emojiUnicode(emoji)}.png`;
            /*eslint-disable*/
            text = text.replaceAll(emoji, `<img style="${EMOJI_STYLE}" data-emoji="${emoji}" src="${emojiSrc}" />`);
            });
        }
    
        return text;
    }

    const replaceEmiji = text => parse(DOMPurify.sanitize(replaceAllTextEmojis(text)));
    const removeEmoji  = str  => str.replaceAll(EMIJI_REGEX, '').replace('☺️','');
    const isOnlyEmojis = str  => !removeEmoji(str).length ? 1 : 0;

    return { replaceEmiji, isOnlyEmojis, loaderAnimation }
}

export default useEmoji